// Per-document audit history : GET /api/logs/content/{contentId}.
//
// Every content mutation log (save with its field-change summary, deploy,
// auto-publish, FX rate publish) is tagged `id:<contentId>` server-side, so one
// call returns the full "who changed what" history of a single document.
//
// Goes through the shared `axios` instance (NOT raw fetch) so the Auth0AxiosBridge
// interceptor attaches the admin Bearer token on deployed instances.
//
// NOTE: HAND-WRITTEN client : lives beside its consumer because `src/API/` is
// wiped and regenerated wholesale by the OpenAPI generator (same convention as
// `src/Components/PageEditor/contentByIdClient.ts`).
import axios from "axios";
import type { LogEntry } from "../../API/Models";

const apiBase = (process.env.REACT_APP_API_URL ?? "").replace(/\/+$/, "");

export async function getContentHistory(contentId: string, limit = 30): Promise<LogEntry[]> {
	const r = await axios.get<LogEntry[]>(
		`${apiBase}/api/logs/content/${encodeURIComponent(contentId)}`,
		{ params: { limit }, withCredentials: true }
	);
	return r.data ?? [];
}
